import type NonEmptyText from '../non-empty-text';
import { assertIsInstanceOfNonEmptyText } from '../assertions';

interface IStakeholderType {
	readonly key: NonEmptyText;
}

export default class StakeholderType implements IStakeholderType {
	public get key(): NonEmptyText {
		return this.#key;
	}

	#key: NonEmptyText;
	public constructor({ key }: IStakeholderType) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
	}
}
